import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import Navbar from '../components/Navbar';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Shield, AlertCircle, LogOut } from 'lucide-react';

const AdminCheckPage = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    // אם יש משתמש והוא אדמין, נווט לדף אדמין
    if (user && user.is_admin) {
      navigate('/admin');
    }
  }, [user, navigate]);

  const handleLogoutAndLogin = () => {
    logout();
    navigate('/auth');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      <Navbar />
      
      <div className="container mx-auto px-4 py-8 max-w-2xl">
        <Card className="glass-effect border-2 border-orange-300">
          <CardHeader>
            <CardTitle className="text-3xl flex items-center gap-3">
              <Shield className="w-8 h-8 text-orange-600" />
              נדרשת הרשאת אדמין
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-6">
              <div className="flex items-start gap-3 p-4 bg-orange-50 border border-orange-200 rounded-lg">
                <AlertCircle className="w-6 h-6 text-orange-600 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-orange-900 mb-2">
                    הרשאות האדמין שלך עודכנו!
                  </h3>
                  <p className="text-orange-800 mb-3">
                    כדי לקבל גישה לפאנל האדמין, עליך להתנתק ולהתחבר מחדש.
                    זה נדרש כדי לרענן את ה-token שלך.
                  </p>
                  <p className="text-sm text-orange-700">
                    💡 זה צריך להתבצע רק פעם אחת. אחרי ההתחברות המחודשת תוכל לגשת לכל תכונות האדמין.
                  </p>
                </div>
              </div>

              <div className="bg-white p-6 rounded-lg border-2">
                <h3 className="font-bold text-lg mb-3">מה עליך לעשות:</h3>
                <ol className="list-decimal list-inside space-y-2 text-gray-700 mb-4">
                  <li>לחץ על הכפתור "התנתק והתחבר מחדש" למטה</li>
                  <li>התחבר שוב עם אותם פרטים (Shafirroy@icloud.com)</li>
                  <li>אחרי ההתחברות תראה כפתור "אדמין" ב-Navbar</li>
                  <li>לחץ על הכפתור "אדמין" כדי להיכנס לפאנל הניהול</li>
                </ol>

                <Button 
                  className="w-full btn-primary text-lg py-6"
                  onClick={handleLogoutAndLogin}
                >
                  <LogOut className="w-5 h-5 ml-2" />
                  התנתק והתחבר מחדש
                </Button>
              </div>

              {user && (
                <div className="text-sm text-gray-600 p-3 bg-gray-50 rounded">
                  <strong>משתמש נוכחי:</strong> {user.full_name} ({user.email})
                  <br />
                  <strong>סטטוס אדמין:</strong> {user.is_admin ? '✅ מאושר' : '❌ לא מאושר (נדרשת התחברות מחדש)'}
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminCheckPage;
